var divider_viewer_default = {
  "divider-container": "IHcyS",
  "divider-container--double": "VnhPj",
  "divider": "eBRMY",
  "divider--single": "a1NPl",
  "divider--double": "itLXO",
  "divider--dashed": "vNJHk",
  "divider--dotted": "IKlUr",
  "divider--small": "MgeK9",
  "divider--medium": "gB1uB",
  "divider--large": "LJj-i",
  "divider--left": "n7no2",
  "divider--center": "w4-SI",
  "divider--right": "_4vRRu",
  "svgFixerContainer": "e4Kjr",
  "emptyChar": "GeGDr"
};
export {
  divider_viewer_default as default
};
//# sourceMappingURL=divider-viewer-scss.js.map
